import React from 'react';

export const OpenFeedBack: React.FC = () => {
  return <div>OpenFeedBack</div>;
};
